import { useCard } from "@orbitalgaming/games-frontend-library"
import { CardComponent } from "components/card/Card"
import {
  CardContainer,
  CardWrapper,
  SideSymbols,
  SuitStyled,
} from "components/card/CardStyled"
import { colors } from "lib/colors"
import React, { Fragment } from "react"
import { BETREPLY_CARD_PROPS } from "./interfaces"

export const CardStackComponent = ({
  cards,
  result,
  win,
}: BETREPLY_CARD_PROPS): JSX.Element => {
  const { handleCardSymbol, handleCardSuit, handleCardColor } = useCard()

  return (
    <Fragment>
      {cards.map((card: string, i: number) => (
        <CardContainer
          key={i}
          left={(i * 22).toString()}
          bot={i === 0 ? "15" : (15 - i * 20).toString()}
        >
          <CardWrapper betReply={true}>
            <CardComponent
              isGameActive={true}
              height='156.04px'
              width='105.81px'
              size='12px'
              background={
                result === "TIE"
                  ? colors.tieColor
                  : win
                  ? colors.cardGreen
                  : colors.secondaryText
              }
              suitColor={handleCardColor(card, "#e7e2de", "#e7e2de")}
            >
              <SideSymbols>
                <p>{handleCardSymbol(card)}</p>
                <SuitStyled suitSize='12px' left='8px' top='30px'>
                  {handleCardSuit(card)}
                </SuitStyled>
              </SideSymbols>
              <SuitStyled suitSize='29px'>{handleCardSuit(card)}</SuitStyled>
            </CardComponent>
          </CardWrapper>
        </CardContainer>
      ))}
    </Fragment>
  )
}
